/**
 * WAT-10279: Split modal components from canvas components.
 *
 * The modal orchestrator is the sole renderer for orchestrated modals;
 * canvas components should never include them. `dynamicPageAdapter` already
 * calls this helper, so most entry points get the split for free. This helper
 * exists for entry points that receive raw pageComponents without running
 * through the adapter (e.g. the recognized App Router page).
 */

import { ORCHESTRATED_MODAL_TYPES, getComponentType } from "./modal-priority";

export interface SplitModalsResult {
  canvasComponents: any[];
  modalComponents: any[];
}

export function splitModalsFromCanvas(components: any[] | undefined): SplitModalsResult {
  const canvasComponents: any[] = [];
  const modalComponents: any[] = [];
  for (const c of components ?? []) {
    if (ORCHESTRATED_MODAL_TYPES.has(getComponentType(c))) {
      modalComponents.push(c);
    } else {
      canvasComponents.push(c);
    }
  }
  return {
    canvasComponents,
    modalComponents
  };
}
